























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'v-number-input' })
export default class VNumberInput extends Vue {
    @Prop({ type: String, default: '' })
    postfix!: string

    @Prop({ type: Number, required: true })
    value!: number

    @Prop({ type: Number, default: 1 })
    step!: number

    @Prop({ type: Number, default: 1 })
    min!: number

    @Prop({ type: Number, default: 999 })
    max!: number

    increment(): void {
        this.update(this.value + this.step)
    }

    decrement(): void {
        this.update(this.value - this.step)
    }

    update(value: number): void {
        value = Math.max(Math.min(value || 0, this.max), this.min)
        this.$emit('input', value);
        (this.$refs.input as HTMLFormElement).value = value
    }
}
